import {
	Box,
	Flex,
	Heading,
	IconButton,
	Table,
	TableContainer,
	Tbody,
	Td,
	Th,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { CloseIcon, ViewIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const ListaDocumentosPedidos = ({ pedidos }) => {
	const navigate = useNavigate();
	return (
		<Box w='100%'>
			<Heading textAlign='center' fontSize='2xl' color='blue.800' my={4}>
				PEDIDOS CON DOCUMENTACIÓN
			</Heading>
			{pedidos.length === 0 ? (
				<Heading textAlign='center' fontSize='xl' color='red.800'>
					No hay pedidos con documentación
				</Heading>
			) : (
				<TableContainer maxH='40rem' overflowY='auto' overflowX='auto'>
					<Table>
						<Thead>
							<Tr>
								<Th
									display={{ base: 'none', md: 'table-cell' }}
								>
									Pedido
								</Th>
								<Th
									display={{ base: 'none', md: 'table-cell' }}
								>
									Cliente
								</Th>
								<Th
									display={{ base: 'none', md: 'table-cell' }}
								>
									Responsable
								</Th>
								<Th
									display={{ base: 'none', md: 'table-cell' }}
								>
									Acciones
								</Th>
							</Tr>
						</Thead>
						<Tbody>
							{pedidos.map(pedido => (
								<Tr key={pedido.uuid}>
									<Td>
										PE - {pedido.tipo_inmueble}{' '}
										{pedido.subtipo_inmueble &&
											pedido.subtipo_inmueble}
									</Td>
									<Td>
										{pedido.cliente?.nombre}{' '}
										{pedido.cliente?.apellidos}
									</Td>
									<Td>
										{pedido.responsable?.nombre}{' '}
										{pedido.responsable?.apellidos}
									</Td>
									<Td>
										<Flex
											gap={1}
											direction={{
												base: 'column',
												md: 'row',
											}}
										>
											<IconButton
												colorScheme='blue'
												size={{ base: 'sm', md: 'md' }}
												icon={<ViewIcon />}
												onClick={() =>
													navigate(
														`/pedidos/ver/${pedido.uuid}`,
													)
												}
											/>
											<IconButton
												isDisabled
												size={{ base: 'sm', md: 'md' }}
												colorScheme='red'
												icon={<CloseIcon />}
											/>
										</Flex>
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</TableContainer>
			)}
		</Box>
	);
};

export default ListaDocumentosPedidos;
